/** @jsxImportSource minimal-view */

import { element, view } from 'minimal-view'
import { app } from './app'
import { hmr } from './hmr'
import { skin } from './skin'
import { Slider } from './slider'
import { SoundEditor } from './sound-editor'
import { classes } from './util/classes'
import { ParamRms } from './param-rms'

export type Mixer = typeof Mixer.State

export const Mixer = hmr(view('mixer',
  class props {
    soundEditor!: SoundEditor
  },
  class local {
    // host = element
  },
  function actions({ $, fn, fns }) {
    return fns(new class actions {
    })
  },
  function effects({ $, fx, deps, refs }) {
    fx(({ soundEditor }) =>
      soundEditor.fx(({ namedRanges }) => {
        $.view = <div class="mixer">
          {namedRanges.map((k) => {
            const range = k
            const param = k.meta!.meta!
            return <div class="mixer-item">
              <div class="rms">
                <ParamRms param={param} />
              </div>
              <div class="mixer-item-top">
                <div class="mixer-item-buttons">
                  <button
                    class={classes({ mute: true, active: param.mute })}
                    onclick={() => {
                      if (param.mute) {
                        const index = param.mute.index
                        let code = soundEditor.$.code
                        code = code.slice(0, index) + code.slice(index + 1)
                        soundEditor.$.code = code
                      }
                      else {
                        let index = param.op.index
                        let code = soundEditor.$.code
                        if (code[index - 1] === 'S') index--
                        code = code.slice(0, index) + 'M' + code.slice(index)
                        soundEditor.$.code = code
                      }
                    }}
                  >
                    M
                  </button>
                  {param.name?.text !== "'main'" && <button
                    class={classes({ solo: true, active: param.solo })}
                    onclick={() => {
                      if (param.solo) {
                        const index = param.solo.index
                        let code = soundEditor.$.code
                        code = code.slice(0, index) + code.slice(index + 1)
                        soundEditor.$.code = code
                      }
                      else {
                        const index = param.op.index
                        let code = soundEditor.$.code
                        code = code.slice(0, index) + 'S' + code.slice(index)
                        soundEditor.$.code = code
                      }
                    }}
                  >
                    S
                  </button>}
                </div>

                <div class="slider">
                  <Slider
                    name={param.name!.text}
                    range={range}
                    param={param}
                    onDraw={() => {
                      soundEditor.$.editor!.$.draw()
                    }}
                    onClick={() => {
                      app.$.selectedParam = param
                      soundEditor.$.editor!.$.line = 0
                      soundEditor.$.editor!.$.col = 0
                      queueMicrotask(() => {
                        soundEditor.$.editor!.$.line = param.target.line
                        soundEditor.$.editor!.$.coli =
                          soundEditor.$.editor!.$.col = param.target.right
                        soundEditor.$.editor!.$.hiddenTextArea!.focus()
                      })
                    }}
                    onRangeUpdate={() => {
                      soundEditor.$.handleRangeUpdate(range, param)
                    }}
                    onPointerDown={() => {
                      requestAnimationFrame(() => {
                        soundEditor.$.draw()
                      })
                    }}
                    onPointerMove={() => { }}
                    onPointerUp={() => {
                      requestAnimationFrame(() => {
                        soundEditor.$.draw()
                      })
                    }}
                  />
                </div>
              </div>
            </div>
          })
          }
        </div>
      })
    )
  }
))
